import { render, staticRenderFns } from "./SizeRecommendationSizeOptionStats.vue?vue&type=template&id=0471d4fd&scoped=true"
import script from "./SizeRecommendationSizeOptionStats.vue?vue&type=script&lang=js"
export * from "./SizeRecommendationSizeOptionStats.vue?vue&type=script&lang=js"
import style0 from "./SizeRecommendationSizeOptionStats.vue?vue&type=style&index=0&id=0471d4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471d4fd",
  null
  
)

/* custom blocks */
import block0 from "./SizeRecommendationSizeOptionStats.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports